import { api } from './client';

export interface PlaceOrderRequest {
    symbol: string;
    direction: 'long' | 'short';
    entry: number;
    stop_loss: number;
    take_profit: number[];
    leverage: number;
    position_size_usdt: number;
    order_type?: 'MARKET' | 'LIMIT';
}

export interface PlaceOrderResponse {
    success: boolean;
    entry_order?: { orderId: number; status: string; [key: string]: unknown } | null;
    sl_order?:    { orderId: number; status: string; [key: string]: unknown } | null;
    tp_orders?:   { orderId: number; status: string; [key: string]: unknown }[];
    error?: string | null;
}

export async function placeOrder(req: PlaceOrderRequest): Promise<PlaceOrderResponse> {
    return api.post<PlaceOrderResponse>('/futures/place-order', req);
}
